import React from "react";
import MutableIcon from "src/components/mutable-icon";
import {
  WorkoutIcon,
  WorkoutType,
} from "src/modules/fithub-shared/interfaces/workout";
import styled from "styled-components";

const Button = styled.button`
  display: flex;
  background-color: #444;
  flex-direction: row;
  font-size: 16px;
  border-radius: 5px;
  width: 200px;
  height: 25vh;
  max-height: 60px;
  min-height: 30px;
  color: white;
  justify-content: space-between;
  align-items: center;

  :not(:last-child) {
    margin-bottom: 5px;
  }

  padding: 10px;

  cursor: pointer;
`;

const CreateModal: React.FC<{
  create: (type: number) => void;
}> = ({ create }) => {
  return (
    <div className="m-auto flex">
      <div className="flex flex-col">
        <Button onClick={() => create(WorkoutType.heating)}>
          <MutableIcon icon={WorkoutIcon(WorkoutType.heating)} />
          <p>Aquecimento</p>
        </Button>
        <Button onClick={() => create(WorkoutType.aerobic)}>
          <MutableIcon icon={WorkoutIcon(WorkoutType.aerobic)} />
          <p>Aeróbico</p>
        </Button>
        <Button onClick={() => create(WorkoutType.weight)}>
          <MutableIcon icon={WorkoutIcon(WorkoutType.weight)} />
          <p>Musculação</p>
        </Button>
        <Button onClick={() => create(WorkoutType.crossfit)}>
          <MutableIcon icon={WorkoutIcon(WorkoutType.crossfit)} />
          <p>Crossfit</p>
        </Button>
      </div>
    </div>
  );
};

export default CreateModal;
